import ExceptionHandling from "./ExceptionHandling.js";
import { useStore, ActionTypes } from "../store";
import instance from "./index";

export default class StockService {
    getStocks(keyword, storeID, start) {
        //SHOW LOADING
        const store = useStore();
        store.dispatch(ActionTypes.PROGRESS_BAR, true);
        const api = "/api/stock_list";
        const formData = new FormData();
        formData.append("keyword", keyword);
        formData.append("storeID", storeID);
        formData.append("start", start);
        return instance()({
            method: "post",
            url: api,
            data: formData,
        })
            .then((res) => res.data)
            .catch((e) => ExceptionHandling.HandleErrors(e))
            .finally(() => {
                store.dispatch(ActionTypes.PROGRESS_BAR, false);
            });
    }

    getItems() {
        //SHOW LOADING
        const store = useStore();
        store.dispatch(ActionTypes.PROGRESS_BAR, true);
        const api = "/api/get_import_stock_list";
        return instance()({
            method: "get",
            url: api,
        })
            .then((res) => res.data)
            .catch((e) => ExceptionHandling.HandleErrors(e))
            .finally(() => {
                store.dispatch(ActionTypes.PROGRESS_BAR, false);
            });
    }

    getHistory(data, page) {
        //SHOW LOADING
        const store = useStore();
        store.dispatch(ActionTypes.PROGRESS_BAR, true);
        const api = "/api/get_stock_history";
        const formData = new FormData();
        formData.append("id", data.id);
        formData.append("start", page);
        return instance()({
            method: "post",
            url: api,
            data: formData,
        })
            .then((res) => res.data)
            .catch((e) => ExceptionHandling.HandleErrors(e))
            .finally(() => {
                store.dispatch(ActionTypes.PROGRESS_BAR, false);
            });
    }

    save(postObj) {
        //SHOW LOADING
        const store = useStore();
        store.dispatch(ActionTypes.PROGRESS_BAR, true);
        const api = "/api/save_csv_data";
        const formData = new FormData();
        formData.append("item_list", JSON.stringify(postObj));
        return instance()({
            method: "post",
            url: api,
            data: formData,
        })
            .then((res) => res.data)
            .catch((e) => ExceptionHandling.HandleErrors(e))
            .finally(() => {
                store.dispatch(ActionTypes.PROGRESS_BAR, false);
            });
    }

    exportSampleStock() {
        const store = useStore();
        store.dispatch(ActionTypes.PROGRESS_BAR, true);
        const api = "/api/export_sample_stock";
        const formData = new FormData();
        return instance()({
            method: "post",
            url: api,
            data: formData,
        })
            .then((res) => res.data)
            .catch((e) => ExceptionHandling.HandleErrors(e))
            .finally(() => {
                store.dispatch(ActionTypes.PROGRESS_BAR, false);
            });
    }

    uploadCSVFile(image) {
        //SHOW LOADING
        const store = useStore();
        store.dispatch(ActionTypes.PROGRESS_BAR, true);
        const api = "/api/import_sample_products";
        const formData = new FormData();
        formData.append("image", image);

        return instance()({
            method: "post",
            url: api,
            data: formData,
        })
            .then((res) => res.data)
            .catch((e) => ExceptionHandling.HandleErrors(e))
            .finally(() => {
                store.dispatch(ActionTypes.PROGRESS_BAR, false);
            });
    }

    updateItem(postObj, stateObj) {
        //SHOW LOADING
        const store = useStore();
        store.dispatch(ActionTypes.PROGRESS_BAR, true);
        const api = "/api/update_stock";
        const formData = new FormData();
        formData.append("id", postObj.id);
        formData.append("reason_description", stateObj.description);
        formData.append("barcode", postObj.barcode);
        formData.append("expiry_date", stateObj.expiryDate);
        formData.append("qty", Number(stateObj.unitQty).toFixed(2));
        formData.append(
            "purchase_price",
            Number(stateObj.packPurchase).toFixed(2)
        );
        formData.append("mrp", Number(stateObj.mRP).toFixed(2));
        formData.append("sale_price", Number(stateObj.mRP).toFixed(2));
        formData.append("batch_no", stateObj.batchNo);
        formData.append(
            "discount_percentage",
            Number(stateObj.disc).toFixed(2)
        );
        formData.append("type_id", stateObj.typeId);

        return instance()({
            method: "post",
            url: api,
            data: formData,
        })
            .then((res) => res.data)
            .catch((e) => ExceptionHandling.HandleErrors(e))
            .finally(() => {
                store.dispatch(ActionTypes.PROGRESS_BAR, false);
            });
    }

    getItem(data) {
        //SHOW LOADING
        //console.log("GET ITEM FUNCTION CALLED IN SERCVICE FILE ",data);
        const store = useStore();
        store.dispatch(ActionTypes.PROGRESS_BAR, true);
        const api = "/api/get_stock/" + data.id;
        return instance()
            .get(api)
            .then((res) => res.data)
            .catch((e) => ExceptionHandling.HandleErrors(e))
            .finally(() => {
                store.dispatch(ActionTypes.PROGRESS_BAR, false);
            });
    }

    deleteItem(data) {
        //SHOW LOADING
        const store = useStore();
        store.dispatch(ActionTypes.PROGRESS_BAR, true);
        const api = "/api/delete_stock";
        const formData = new FormData();
        formData.append("id", data.id);
        formData.append("status", data.status);
        return instance()({
            method: "post",
            url: api,
            data: formData,
        })
            .then((res) => res.data)
            .catch((e) => ExceptionHandling.HandleErrors(e))
            .finally(() => {
                store.dispatch(ActionTypes.PROGRESS_BAR, false);
            });
    }

    activateItem(data) {
        //SHOW LOADING
        const store = useStore();
        store.dispatch(ActionTypes.PROGRESS_BAR, true);
        const api = "/api/activate_stock";
        const formData = new FormData();
        formData.append("id", data.id);
        formData.append("status", data.status);
        return instance()({
            method: "post",
            url: api,
            data: formData,
        })
            .then((res) => res.data)
            .catch((e) => ExceptionHandling.HandleErrors(e))
            .finally(() => {
                store.dispatch(ActionTypes.PROGRESS_BAR, false);
            });
    }

    saveAddition(postObj, paymentList, savedItem, itemState, counterEntry) {
        // data modifications
        itemState.unitQty = Number(itemState.unitQty).toFixed(2); 
        itemState.packPurchase = Number(itemState.packPurchase).toFixed(2); 
        itemState.mRP = Number(itemState.mRP).toFixed(2);
        itemState.disc = Number(itemState.disc).toFixed(2); 
        itemState.reason_description = itemState.description;

        //SHOW LOADING
        const store = useStore();
        store.dispatch(ActionTypes.PROGRESS_BAR, true);
        const api = "/api/save_st_ad_addition";
        const formData = new FormData();
        formData.append("profile_id", savedItem.profileID);
        formData.append("payment_list", JSON.stringify(paymentList));
        formData.append("discount", postObj.discount);
        formData.append("total_paid", postObj.totalPaid);
        formData.append("total_tendered", postObj.totalTendered);
        formData.append("total_change", postObj.totalChange);
        formData.append("total_gross_amt", postObj.totalGrossAmt);
        formData.append("total_bill", postObj.totalBill);
        formData.append("total_tax1", postObj.totalTax1);
        formData.append("total_tax2", postObj.totalTax2);
        formData.append("total_tax3", postObj.totalTax3);
        formData.append("total_tax", postObj.totalTax);
        formData.append("description", postObj.description);
        formData.append("payment_method", postObj.paymentMethod);
        formData.append("bill_no", postObj.billNo);
        formData.append("status", postObj.status);
        formData.append("type", postObj.type);
        formData.append("search_receipt_no", postObj.searchReceiptNo);
        formData.append("item", JSON.stringify(savedItem));
        formData.append("state", JSON.stringify(itemState));
        formData.append("counter_entry", JSON.stringify(counterEntry));
        formData.append("total_goods_value", postObj.totalGoodsValue);

        return instance()({
            method: "post",
            url: api,
            data: formData,
        })
            .then((res) => res.data)
            .catch((e) => ExceptionHandling.HandleErrors(e))
            .finally(() => {
                store.dispatch(ActionTypes.PROGRESS_BAR, false);
            });
    }

    saveDeduction(postObj, paymentList, savedItem, itemState, counterEntry) {
        // data modifications
        itemState.unitQty = Number(itemState.unitQty).toFixed(2); 
        itemState.packPurchase = Number(itemState.packPurchase).toFixed(2); 
        itemState.mRP = Number(itemState.mRP).toFixed(2); 
        itemState.disc = Number(itemState.disc).toFixed(2); 
        itemState.reason_description = itemState.description;

        //SHOW LOADING
        const store = useStore();
        store.dispatch(ActionTypes.PROGRESS_BAR, true);
        const api = "/api/save_st_ad_deduction";
        const formData = new FormData();
        formData.append("profile_id", savedItem.profileID);
        formData.append("payment_list", JSON.stringify(paymentList));
        formData.append("discount", postObj.discount);
        formData.append("total_paid", postObj.totalPaid);
        formData.append("total_tendered", postObj.totalTendered);
        formData.append("total_change", postObj.totalChange);
        formData.append("total_gross_amt", postObj.totalGrossAmt);
        formData.append("total_bill", postObj.totalBill);
        formData.append("total_tax1", postObj.totalTax1);
        formData.append("total_tax2", postObj.totalTax2);
        formData.append("total_tax3", postObj.totalTax3);
        formData.append("total_tax", postObj.totalTax);
        formData.append("description", postObj.description);
        formData.append("payment_method", postObj.paymentMethod);
        formData.append("bill_no", postObj.billNo);
        formData.append("status", postObj.status);
        formData.append("type", postObj.type);
        formData.append("search_receipt_no", postObj.searchReceiptNo);
        formData.append("item", JSON.stringify(savedItem));
        formData.append("state", JSON.stringify(itemState));
        formData.append("counter_entry", JSON.stringify(counterEntry));
        formData.append("total_goods_value", postObj.totalGoodsValue);

        return instance()({
            method: "post",
            url: api,
            data: formData,
        })
            .then((res) => res.data)
            .catch((e) => ExceptionHandling.HandleErrors(e))
            .finally(() => {
                store.dispatch(ActionTypes.PROGRESS_BAR, false);
            });
    }

    thawStock(productId, batchNo) {
        const store = useStore();
        store.dispatch(ActionTypes.PROGRESS_BAR, true);
        const api = "/api/thaw_stock";
        const formData = new FormData();
        formData.append("product_id", productId);
        formData.append("batch_no", batchNo);
        return instance()({
            method: "post",
            url: api,
            data: formData,
        })
            .then((res) => res.data)
            .catch((e) => ExceptionHandling.HandleErrors(e))
            .finally(() => {
                store.dispatch(ActionTypes.PROGRESS_BAR, false);
            });
    }

    searchStockForTransfer(keyword) {
        const store = useStore();
        store.dispatch(ActionTypes.PROGRESS_BAR, true);
        const formData = new FormData();
        formData.append("keyword", keyword);
        return instance()({ method: "post", url: "/api/search_items_for_transfer", data: formData })
            .then(res => res.data)
            .catch(e => ExceptionHandling.HandleErrors(e))
            .finally(() => store.dispatch(ActionTypes.PROGRESS_BAR, false));
    }

    refreshFreeze(productId, batchNo) {
        const api = "/api/refresh_stock_freeze";
        const formData = new FormData();
        formData.append("product_id", productId);
        formData.append("batch_no", batchNo);
        return instance()({
            method: "post",
            url: api,
            data: formData,
        })
            .then((res) => res.data)
            .catch((e) => {

                console.warn("refreshFreeze failed:", e);
                return { alert: "error", expired: false };
            });
    }
}
